import React,{useState,useEffect} from 'react'
import { getMoneyOwedNext3EventsAllResellers } from 'network/ApiAxiosTickets';
import { Row, Col } from 'react-bootstrap';
import { Button } from 'reactstrap';
import { markOrdersPaid } from 'network/ApiAxiosTickets';

function NextEventsOwedAll(props) {
    const [money, setMoney] = useState(0);
    let userID = JSON.parse(localStorage.getItem("user"))._id;
    let userName = JSON.parse(localStorage.getItem("user")).name;
    useEffect(() => {
        fetchSellerDeposits()
    }, []);

    const fetchSellerDeposits = async()=>{
        const resp = await getMoneyOwedNext3EventsAllResellers()
        if(resp.data.success){
          setMoney(resp.data.events)
        }
    }

    const markPaid = async(eventId,sellerName)=>{
        const resp = await markOrdersPaid(eventId,sellerName)
        if(resp.data.success){
          window.location.reload();
        }else{
          alert('Error marking orders as paid');
        }
    }

  return (
    money ?
      <Row>
        {money.map((eventItem)=>{
          return <>
            <Row key={eventItem._id} className='w-100 ml-2'>
              <h3 className=' text-white'>{eventItem.sellerName}</h3>
            </Row>

            {
              eventItem.events.map((event)=>{
              return <Row className='w-100'>
                <Col xs={5} md={5} className="text-center">
                  <img src={'https://new.geticketsonline.com/files/product-images/' + event.posterImage} alt={event.name} style={{width: '100px', height: '100px'}} />
                  <p className=' text-white'>{event.name.length > 30 ? event.name : event.name + ' ' + event.checkinFrom.split('T')[0]}</p>
                </Col>
                <Col xs={5} md={5} className="text-center align-content-center">
                  <h4 className=' text-white'>Tickets sold: {event.tickets}</h4>
                  <h4 className=' text-white'>Total sold: {event.total}€</h4>
                </Col>
                <Col xs={2} md={2} className="text-center align-content-center">
                  <Button className="btn btn-info" onClick={() => markPaid(event._id,eventItem.sellerName)} >Pay</Button>
                </Col>
              </Row>
              })
            }

          </>
        })

        
        }
      </Row> : null
  )
}

export default NextEventsOwedAll